import Button from "../../components/button";
import React, { useCallback, useContext, useEffect, useRef, useState } from "react";
import ModalSimple from "../../components/modal-simple";
import styles from './style.module.css';
import { useNavigate, useSearchParams } from "react-router";
import { DEFAULT_DEVICE_LIMIT, DEVICE_LIMITS, DeviceLimit, PaymentMethod, SUBSCRIPTION_TYPE } from "../../context/types";
import { createOrder, getLastOrder, getOrderById } from "../../api/order";
import Spinner from "../../components/spinner";
import { DataContext } from "../../context/dataProvider";
import { openExternalUrl } from "../../utils/telegram";

function BuyConfirmationPage() {
  const context = useContext(DataContext);
  const navigate = useNavigate();
  const [payLink, setPayLink] = useState<string | null>(null);
  const [searchParams] = useSearchParams();
  const tariff = searchParams.get('t');
  const method = searchParams.get('m');
  const deviceParam = searchParams.get('d');
  const parsedDevice = deviceParam ? Number(deviceParam) : NaN;
  const deviceLimit: DeviceLimit = DEVICE_LIMITS.includes(parsedDevice as DeviceLimit)
    ? (parsedDevice as DeviceLimit)
    : DEFAULT_DEVICE_LIMIT;
  const newOrder = searchParams.get('newOrder');
  const status = searchParams.get('status');
  const orderId = searchParams.get('orderId');
  // 'upgrade' — доплата за увеличение лимита устройств (создаётся не здесь, см. AddDeviceModal),
  // сюда попадаем только чтобы поллить статус и корректно обработать fail-редирект.
  const kind = searchParams.get('k');
  const hasProcessed = useRef(false);

  const pollingIntervalRef = useRef<ReturnType<typeof setInterval> | null>(null);
  const pollingTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const userCancelledRef = useRef(false);

  const cancelPolling = () => {
    if (pollingIntervalRef.current) {
      clearInterval(pollingIntervalRef.current);
      pollingIntervalRef.current = null;
    }
    if (pollingTimeoutRef.current) {
      clearTimeout(pollingTimeoutRef.current);
      pollingTimeoutRef.current = null;
    }
  };

  const goToFail = useCallback(() => {
    const params = new URLSearchParams({ t: tariff || '' });
    if (kind) params.set('k', kind);
    navigate(`/payment/fail?${params.toString()}`);
  }, [navigate, tariff, kind]);

  // Поллинг статуса заказа (работает и в Mini App, и в браузере)
  const startPolling = useCallback((orderIdToCheck: number) => {
    cancelPolling();
    userCancelledRef.current = false;

    pollingIntervalRef.current = setInterval(async () => {
      const order = await getOrderById(orderIdToCheck);
      if (order && String(order.status).toLowerCase() === 'paid') {
        cancelPolling();
        await context?.updateData();
        navigate('/payment/success');
      }

      if (order && String(order.status).toLowerCase() === 'declined') {
        cancelPolling();
        goToFail();
      }
    }, 5000);
    pollingTimeoutRef.current = setTimeout(() => {
      if (userCancelledRef.current) return;
      cancelPolling();
      goToFail();
    }, 300000);
  }, [goToFail, context, navigate]);

  const handleCancel = () => {
    userCancelledRef.current = true;
    cancelPolling();
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate('/select-tariff');
    }
  };

  useEffect(() => {
    const createOrderToBuyAccess = async () => {
      if (tariff && method && !hasProcessed.current) {
        if (status==='pending') {
          hasProcessed.current = true;
          if (newOrder) {
              const newParams = new URLSearchParams(searchParams);
              newParams.delete('newOrder');
              navigate(
                { 
                  pathname: window.location.pathname, 
                  search: newParams.toString() 
                }, 
                { replace: true }
            );
            
            const response = await createOrder({
              paymentMethod: method as PaymentMethod,
              orderType: tariff as SUBSCRIPTION_TYPE,
              deviceLimit,
            });
            if (response) {
              openExternalUrl(response.url);
              startPolling(response.orderId);
            }
          } else {
            const payUrl = await getLastOrder();
            if (payUrl) {
              setPayLink(payUrl);
            }
          }
        }
      }

      if (status==='success') {
          const oid = searchParams.get('orderId');
          const parsedOid = oid ? Number(oid) : NaN;
          if (!Number.isNaN(parsedOid)) {
            startPolling(parsedOid);
          }
        }
    }
    createOrderToBuyAccess();
    return () => {
      cancelPolling();
    };
  }, [
    tariff,
    method,
    deviceLimit,
    status,
    orderId,
    payLink,
    navigate,
    newOrder,
    searchParams,
    startPolling,
  ]);

  const moveToPayment = (payLink: string) => {
    openExternalUrl(payLink);
  }

  return (
    <div className="confirmation">
      <ModalSimple>
        <div className={styles.container}>
          <div>
            <h2>Ожидание оплаты</h2>
            <p>Проверяем оплату подписки</p>
          </div>
            <div className={styles.spinner}>
              <Spinner />
            </div>
        </div>
        <div style={{ display: 'grid', gap: 8, width: '100%' }}>
          {/* <Button
            label="Перейти к оплате"
            onClick={() => {
              const handleClick = async () => {
                let link = payLink;
                if (!link) {
                  const last = await getLastOrder();
                  if (last) {
                    setPayLink(last);
                    link = last;
                  }
                }
                if (!link) return;
                moveToPayment(link);
              };
              void handleClick();
            }}
          /> */}
          <Button label="Отмена" variant="secondary" onClick={handleCancel} />
        </div>
      </ModalSimple>
    </div>
  );
}

export default BuyConfirmationPage;
